import React from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'

function SreDeleteModal({ event, bulkCount, onConfirm, onCancel, error }) {
  return (
    <Modal show animation={false}>
      <Modal.Header>
        <Modal.Title>{bulkCount > 1 ? 'Delete Events' : 'Delete Event'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {bulkCount > 1 ? (
          <p>Delete {bulkCount} selected events? This cannot be undone.</p>
        ) : (
          <>
            <p>Delete this event?</p>
            <p className="text-muted small mb-0">{event.sre_timestamp}</p>
          </>
        )}
        {error && (
          <Alert variant="danger" className="mt-3 mb-0" role="alert">
            {error}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SreDeleteModal
